export const UserRoutes = {
getRoles:"/user/getRoles",
getUsers:"/user/getUsersByRole",
};
